import React, { useState } from 'react';
import '../../App.css';
import './Releases.css';

// Solo releases, from Boom's own catalog spreadsheet — every entry has real
// art and an Apple Music link. `spotifyLink` is included wherever the release
// could be confirmed on Spotify; a few older, lower-traffic releases aren't
// indexed there and simply fall back to Apple Music.
const releases = [
    { title: 'Black Sky (Revisited)', year: 2024, meta: 'Single · Ambient · Audiocomm International', link: 'https://music.apple.com/us/album/black-sky-revisited-single/1771537999', spotifyLink: 'https://open.spotify.com/album/1JImuY3jZaLKbTkRpLzD0W', img: '/images/blacksky.jpeg' },
    { title: 'Under the Influence', year: 2024, meta: 'Single · Techno · Audiocomm International', link: 'https://music.apple.com/us/album/under-the-influence-single/1769206920', spotifyLink: 'https://open.spotify.com/album/6PII5s32Gwwro9L5BHOndZ', img: '/images/underinfluence.jpeg' },
    { title: 'Xoxo', year: 2024, meta: 'Single · Ambient Techno · Audiocomm International', link: 'https://music.apple.com/us/album/xoxo-single/1742718232', spotifyLink: 'https://open.spotify.com/album/07sq8M3RsaKy6G6Hjys5IR', img: '/images/xoxo.jpeg' },
    { title: 'Open Conversation', year: 2023, meta: 'EP · Techno · Audiocomm International', link: 'https://music.apple.com/us/album/open-conversation-ep/1703787142', spotifyLink: 'https://open.spotify.com/album/2WxPRYJuDwf1PKIkDmreHS', img: '/images/FRONT_COVER.png' },
    { title: 'Manufactured Safety', year: 2023, meta: 'Single · Hardcore Techno · Audiocomm International', link: 'https://music.apple.com/us/album/manufactured-safety-ep/1678832929', spotifyLink: 'https://open.spotify.com/album/3FHjxDu7wr9OQxw4XBI8qq', img: '/images/manufactured_safety_1.png' },
    { title: 'Ring Ring', year: 2022, meta: 'EP · Techno · Audiocomm International', link: 'https://music.apple.com/us/album/ring-ring/1661191348', spotifyLink: 'https://open.spotify.com/album/4MxJhRMEb4R8rjoGcYfAs4', img: '/images/ringring.jpeg' },
    { title: 'HUAC-A-Mole', year: 2022, meta: 'LP · Techno, Breakbeat · Audiocomm International', link: 'https://music.apple.com/us/album/huac-a-mole/1650832240', spotifyLink: 'https://open.spotify.com/album/62bk6xWqrQAV5luCX7KMOw', img: '/images/HUAC-A-MOLE_600px.png' },
    { title: 'Chuck', year: 2021, meta: 'Single · Ambient · Audiocomm International', link: 'https://music.apple.com/us/album/chuck-single/1600801785', spotifyLink: 'https://open.spotify.com/album/6ZNwpy9I18JowIo2zjHMjg', img: '/images/chuck.jpeg' },
    { title: 'Bad Move', year: 2021, meta: 'Single · Dark Techno · Audiocomm International', link: 'https://music.apple.com/us/album/bad-move-single/1600797973', spotifyLink: 'https://open.spotify.com/album/0n3pTq8fcw3JTftX2VJn2U', img: '/images/badmove.jpeg' },
    { title: 'Monody', year: 2021, meta: 'Single · Dark Techno · Audiocomm International', link: 'https://music.apple.com/us/album/monody-single/1600401643', spotifyLink: 'https://open.spotify.com/album/6aJxAvd4a7zfhpyC6mnLUn', img: '/images/monody.jpeg' },
    { title: 'Membranes', year: 2021, meta: 'LP · Ambient Techno · Audiocomm International', link: 'https://music.apple.com/us/album/membranes/1560045082', spotifyLink: 'https://open.spotify.com/album/2XuSMFWYpsSxJxzHXDbOPH', img: '/images/Boom-chr-Paige-Membranes.jpg' },
    { title: 'Above London', year: 2021, meta: 'Single · Ambient · Audiocomm International', link: 'https://music.apple.com/us/album/above-london-single/1565033320', img: '/images/Above-London-Single.jpg' },
    { title: 'Screaming Blue', year: 2017, meta: 'Single · Techno · Teknofonic Recordings', link: 'https://music.apple.com/us/album/screaming-blue/1301470080?i=1301470081', spotifyLink: 'https://open.spotify.com/album/69SZkOyNwBHlNFb8OFrmYl', img: '/images/screaming-blue.png' },
    { title: 'Arcade', year: 2016, meta: 'Single · Techno · Teknofonic Recordings', link: 'https://music.apple.com/us/album/arcade-single/1301424526', spotifyLink: 'https://open.spotify.com/album/6yjHmxO8NMACOrJkaLYJSP', img: '/images/Boom-Arcade.jpg' },
    { title: 'Minimalist', year: 2016, meta: 'Single · Deep House · Teknofonic Recordings', link: 'https://music.apple.com/us/album/minimalist-single/1131664313', spotifyLink: 'https://open.spotify.com/album/3poPCiOK7AguHDxqwmFtXN', img: '/images/minimalist.jpeg' },
    { title: 'Turn It Around', year: 2016, meta: 'Single · House · Teknofonic Recordings', link: 'https://music.apple.com/us/album/turn-it-around-single/1119642039', spotifyLink: 'https://open.spotify.com/album/7pOs8RiudMeejERlwvUVXp', img: '/images/turn-it-around.jpeg' },
    { title: 'Venice Boulevard', year: 2015, meta: 'Single · House · Teknofonic Recordings', link: 'https://music.apple.com/us/album/venice-boulevard-single/1042734318', spotifyLink: 'https://open.spotify.com/album/4VH1UlIvmIRw6pnliywchU', img: '/images/Venice-blvd.jpeg' },
    { title: 'House For Serial Killers', year: 2015, meta: 'EP · Techno · Teknofonic Recordings', link: 'https://music.apple.com/us/album/house-for-serial-killers-ep/1056683883', spotifyLink: 'https://open.spotify.com/album/01UlFQnIuRSWMIcfxmXkKi', img: '/images/house-for-serial-killers.jpg' },
    { title: 'Palisades Drive', year: 2015, meta: 'Single · House · Teknofonic Recordings', link: 'https://music.apple.com/us/album/palisades-drive-single/1020304862', spotifyLink: 'https://open.spotify.com/album/41TTzxfIlzMfXaxmL5yOpu', img: '/images/Palisades-Drive.jpg' },
    { title: 'Catwalk Karma', year: 2015, meta: 'Single · Techno · Teknofonic Recordings', link: 'https://music.apple.com/us/album/catwalk-karma-single/994651826', spotifyLink: 'https://open.spotify.com/album/5MTsrBVDD5VxI7gBa8mRCZ', img: '/images/Catwalk-Karma-1.jpg' },
    { title: 'Sept', year: 2014, meta: 'EP · Techno · Audiocomm International', link: 'https://music.apple.com/us/album/sept-ep/904940372', img: '/images/sept-cover.jpg' },
    { title: 'Who Is Charlie?', year: 2013, meta: 'Single · Breakbeat, Techno · Audiocomm International', link: 'https://music.apple.com/us/album/who-is-charlie-single/615313196', img: '/images/charlie.png' },
    { title: 'Primary', year: 2007, meta: 'Album · Breakbeat, Techno · Audiocomm International', link: 'https://music.apple.com/us/album/primary/259251850', spotifyLink: 'https://open.spotify.com/album/4UMFMudWJjmVeFX36ju2gV', img: '/images/primary.jpg' },
    { title: 'Breakcore Restoration', year: 2005, meta: 'EP · Big Beat, Breakbeat · Audiocomm International', link: 'https://music.apple.com/us/album/breakcore-restoration/80850439', img: '/images/breakcore-cover.jpg' },
];

// Everything credited to The Watchmen / Society.Burning / Society Burning —
// same band across its history (per the bio: The Watchmen became Society Burning in '91).
const societyBurning = [
    { title: 'Ready End User', year: 2021, meta: 'Album · Society Burning Self Release', link: 'https://www.discogs.com/master/2066992', img: '/images/sobu-reu.png' },
    { title: "D3l3te Up10ad", year: 2015, meta: 'Album · Audiocomm International', link: 'https://www.discogs.com/master/1513442', img: '/images/sobu-du.png' },
    { title: 'Internal Combustion', year: 2010, meta: 'Album · Audiocomm International', link: 'https://www.discogs.com/master/2380363', img: '/images/sobu-ic.png' },
    { title: 'State Of Decay', year: 2009, meta: 'Album · Audiocomm International', link: 'https://www.discogs.com/master/2380360' , img: '/images/sobu-sod.png'},
    { title: 'Tactiq', year: 1997, meta: 'Album · Re-constriction Records', link: 'https://www.discogs.com/release/188239' , img: '/images/sobu-tactiq.png'},
    { title: 'Entropy Lingua', year: 1996,  meta: 'Album · Re-constriction Records', link: 'https://www.discogs.com/master/1031008', img: '/images/sobu-el.png' },
    { title: 'Plague', year: 1992, meta: 'Album · Prescient Thought (as The Watchmen)', link: 'https://www.discogs.com/release/1355575', img: '/images/plague.png' },
    { title: 'Is God In Showbusiness Too?', year: 1991, meta: 'Album · Prescient Thought (as The Watchmen)', link: 'https://www.discogs.com/release/2338163', img: '/images/showbusiness.png' },
];

// Remix work and compilation/guest appearance credits, per Discogs.
const credits = [
    { title: 'Replicator', artist: 'UCNX', year: 2014, role: 'Remix', link: 'https://www.discogs.com/master/721003' },
    { title: 'Cold Waves II Sampler', artist: 'Various', year: 2013, role: 'Remix — "Stone (Remix)"', link: 'https://www.discogs.com/release/5045722' },
    { title: 'Electronic Saviors, Vol. II: Recurrence', artist: 'Various', year: 2012, role: 'Compilation appearance', link: 'https://www.discogs.com/master/434778' },
    { title: 'Prepare To Be Refrigerated', artist: 'Everything Goes Cold', year: 2008, role: 'Remix', link: 'https://www.discogs.com/master/3555214' },
    { title: 'The Challenge From Beyond (A Tribute To H.P. Lovecraft)', artist: 'Various', year: 2000, role: 'Compilation appearance', link: 'https://www.discogs.com/master/58402' },
    { title: 'Carry Me', artist: 'Leæther Strip', year: 2000, role: 'Remix', link: 'https://www.discogs.com/master/29388' },
    { title: 'Cryonica Tanz V.1', artist: 'Various', year: 2000, role: 'Remix — "Secret (Club Mix)"', link: 'https://www.discogs.com/release/321583' },
    { title: 'Speak Clearly', artist: 'Purr Machine', year: 1999, role: 'Remix', link: 'https://www.discogs.com/release/362615' },
    { title: "Yes, I'm Limited Vol. III", artist: 'Leæther Strip', year: 1998, role: 'Remix', link: 'https://www.discogs.com/master/29392' },
    { title: 'Choking On Lilies', artist: 'Hexedene', year: 1998, role: 'Remix', link: 'https://www.discogs.com/master/3927' },
    { title: 'Aftermath', artist: 'Battery', year: 1998, role: 'Remix — "Aftermath (Sobu Remix)"', link: 'https://www.discogs.com/release/163949' },
    { title: 'Watz Your Program', artist: 'THD', year: 1998, role: 'Remix', link: 'https://www.discogs.com/release/266004' },
    { title: "Gravity's Rim", artist: 'Vampire Rodents', year: 1996, role: 'Appearance', link: 'https://www.discogs.com/master/2090185' },
    { title: 'Clockseed', artist: 'Vampire Rodents', year: 1995, role: 'Appearance', link: 'https://www.discogs.com/master/2090146' },
    { title: 'Rivet Head Culture', artist: 'Various', year: 1993, role: 'Appearance — "Party Girl"', link: 'https://www.discogs.com/release/118613' },
];

// Shared platform-toggle link logic for anything with a spotifyLink/link pair.
function resolveHref(item, platform) {
    const useSpotify = platform === 'spotify' && item.spotifyLink;
    const href = useSpotify ? item.spotifyLink : item.link;
    const fallback = platform === 'spotify' && item.link && !item.spotifyLink;
    return { href, fallback };
}

// Card layout — bigger art, used for sections where every item has cover
// art (main releases, Society Burning).
function ReleaseCard({ item, platform }) {
    const { href, fallback } = resolveHref(item, platform);

    return (
        <li className='release-card'>
            <a className='release-card-link' href={href} target='_blank' rel='noreferrer'>
                {item.img ? (
                    <img className='release-card-thumb' src={item.img} alt={item.title} />
                ) : (
                    <div className='release-card-thumb release-card-thumb--placeholder' aria-hidden='true'>
                        <i className='fas fa-music' />
                    </div>
                )}
                <span className='release-card-title'>{item.title}</span>
                <span className='release-card-meta'>
                    {item.year ? `${item.year}` : ''}
                    {item.meta ? ` · ${item.meta}` : ''}
                    {fallback ? ' · Apple Music only' : ''}
                </span>
            </a>
        </li>
    );
}

// Compact row layout — for the credits/remixes section, which has no art.
function ReleaseRow({ item, showArtist }) {
    return (
        <li className='release-item'>
            <div className='release-thumb release-thumb--placeholder' aria-hidden='true'>
                <i className='fas fa-music' />
            </div>
            <div className='release-info'>
                <a className='release-title' href={item.link} target='_blank' rel='noreferrer'>
                    {item.title}
                </a>
                <span className='release-meta'>
                    {showArtist && item.artist ? `${item.artist} · ` : ''}
                    {item.year ? `${item.year}` : ''}
                    {item.meta ? ` · ${item.meta}` : ''}
                    {item.role ? ` · ${item.role}` : ''}
                </span>
            </div>
        </li>
    );
}

function PlatformToggle({ platform, setPlatform }) {
    return (
        <div className='platform-toggle' role='group' aria-label='Preferred music platform'>
            <span className='platform-toggle-label'>Open links in</span>
            <div className='platform-toggle-switch'>
                <button
                    type='button'
                    className={platform === 'apple' ? 'platform-toggle-option active' : 'platform-toggle-option'}
                    onClick={() => setPlatform('apple')}
                    aria-pressed={platform === 'apple'}
                >
                    Apple Music
                </button>
                <button
                    type='button'
                    className={platform === 'spotify' ? 'platform-toggle-option active' : 'platform-toggle-option'}
                    onClick={() => setPlatform('spotify')}
                    aria-pressed={platform === 'spotify'}
                >
                    Spotify
                </button>
            </div>
        </div>
    );
}

function Releases() {
    const [platform, setPlatform] = useState('apple');

    return (
        <div className='generalContainer'>
            <h3 className='page-heading'>Releases</h3>
            <div className='releases-page'>
                <PlatformToggle platform={platform} setPlatform={setPlatform} />

                <section className='releases-section'>
                    <ul className='release-grid'>
                        {releases.map((item) => (
                            <ReleaseCard key={item.title} item={item} platform={platform} />
                        ))}
                    </ul>
                </section>

                <section className='releases-section'>
                    <h4 className='releases-section-title'>With Society Burning</h4>
                    <ul className='release-grid'>
                        {societyBurning.map((item) => (
                            <ReleaseCard key={item.title} item={item} />
                        ))}
                    </ul>
                </section>

                <section className='releases-section'>
                    <h4 className='releases-section-title'>Remixes &amp; Collaborations</h4>
                    <ul className='release-list release-list--compact'>
                        {credits.map((item) => (
                            <ReleaseRow key={`${item.title}-${item.artist}`} item={item} showArtist />
                        ))}
                    </ul>
                </section>

                <p className='releases-source'>
                    Society Burning and remix/collaboration credits sourced from{' '}
                    <a
                        href='https://www.discogs.com/artist/240302-Boom-chr-Paige'
                        target='_blank'
                        rel='noreferrer'
                    >
                        Discogs
                    </a>
                    . Missing something or have a better cover image? Let me know.
                </p>
            </div>
        </div>
    );
}

export default Releases;
